import React from 'react'
import { __ } from 'i18n-for-browser'
import '../config/i18n'

import '../style/App.css'
import '../style/CcBrowser.css'
import '../style/PsEdit.css'
import '../style/OutputOptions.css'
import '../style/Spectrum.css'
import '../style/LayerProperty.css'

import Header from './Shared/Header'
import Main from './Shared/Main'
import { shouldHideButton } from '../lib/skycity'

import { Toast } from '@react/react-spectrum/Toast'

export default function App () {
    if (navigator.onLine) {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('d') !== '1') {
            const hostname = window.location.hostname
            let targetUrl = ''
            if (hostname === 'skycity-stage.adobedice.com' || hostname === 'skycity-dev.adobedice.com') {
            // if (hostname === 'skycity-stage.adobedice.com' || hostname === 'skycity-dev.adobedice.com' || hostname.includes('localhost')) {
                targetUrl = 'https://stage.cloudcity.corp.adobe.com/'
            } else if (hostname === 'skycity.adobedice.com') {
                targetUrl = 'https://cloudcity.corp.adobe.com/'
            }
            if (targetUrl) {
                window.location.replace(targetUrl)
            }
        }
        return <div className="adobe-skycity-app">
            {shouldHideButton() ? null : <Header />}
            <Main />
        </div>
    } else {
        return (
            <div className="adobe-skycity-app">
                {shouldHideButton() ? null : <Header />}
                <Toast variant="error">{__('error_offline')}</Toast>
            </div>
        )
    }
}
